/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    static get observedAttributes() {
      return [
        'data-cart-total',
        'data-cart-total-inc',
        'data-cart-total-ex',
        'data-minimum',
        'data-minimum-inc',
        'data-minimum-ex'
      ];
    }

    constructor() {
      super();
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.cacheElements();
      this.update();
    }

    attributeChangedCallback() {
      this.update();
    }

    cacheElements() {
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      this.amountElement = this.querySelector('.free-shipping--text .vat-price-value');
    }

    parseCents(value, fallback = 0) {
      const parsed = Number(value);

      if (Number.isFinite(parsed)) {
        return parsed;
      }

      return Number.isFinite(fallback) ? fallback : 0;
    }

    getCentsAttribute(name, fallback = 0) {
      return this.parseCents(this.getAttribute(name), fallback);
    }

    setAmountAttributes(inc, ex) {
      if (!this.amountElement) {
        return;
      }

      this.amountElement.setAttribute('data-price-inc', Math.max(0, inc));
      this.amountElement.setAttribute('data-price-ex', Math.max(0, ex));
    }

    toggleMessages(showRemaining) {
      if (this.remainingText) {
        this.remainingText.style.display = showRemaining ? '' : 'none';
      }

      if (this.fullText) {
        this.fullText.style.display = showRemaining ? 'none' : '';
      }
    }

    update() {
      if (!this.isConnected) {
        return;
      }

      this.cacheElements();

      const totalInc = this.getCentsAttribute('data-cart-total-inc', this.getCentsAttribute('data-cart-total', 0));
      const totalEx = this.getCentsAttribute('data-cart-total-ex', totalInc);
      const minimumInc = this.getCentsAttribute('data-minimum-inc', this.getCentsAttribute('data-minimum', 0));
      const minimumEx = this.getCentsAttribute('data-minimum-ex', minimumInc);

      let percentage = 1;

      if (minimumInc > 0 && totalInc < minimumInc) {
        const remainingInc = minimumInc - totalInc;
        const remainingEx = minimumEx - totalEx;

        percentage = Math.max(0, totalInc / minimumInc);
        this.setAmountAttributes(remainingInc, remainingEx);
        this.toggleMessages(true);
      } else {
        this.setAmountAttributes(0, 0);
        this.toggleMessages(false);
      }

      this.style.setProperty('--percentage', Math.max(0, Math.min(percentage, 1)));
    }
  }

  customElements.define('free-shipping', FreeShipping);
}